"use strict";

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSyntaxHighlighter = _interopRequireDefault(require("react-syntax-highlighter"));

var _hljs = require("react-syntax-highlighter/dist/esm/styles/hljs");

var _reactCopyToClipboard = require("react-copy-to-clipboard");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ExportHTMLModal = function ExportHTMLModal(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$exportedHTML = _ref.exportedHTML,
      exportedHTML = _ref$exportedHTML === void 0 ? '' : _ref$exportedHTML;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  var onCopied = function onCopied() {
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 3000);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "ExportHTMLModal"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal fade",
      id: id,
      tabIndex: "-1",
      role: "dialog",
      "aria-labelledby": "MenuBuilder-ExportHTMLPopup-Title",
      "aria-hidden": "true"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal-dialog modal-lg modal-dialog-centered",
      role: "document"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal-content"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal-header"
    },
    /*#__PURE__*/
    _react["default"].createElement("h5", {
      className: "modal-title",
      id: "MenuBuilder-ExportHTMLPopup-Title"
    }, "Export HTML"),
    /*#__PURE__*/
    _react["default"].createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    /*#__PURE__*/
    _react["default"].createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal-body"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactSyntaxHighlighter["default"], {
      language: "html",
      style: _hljs.docco,
      className: "codeHighlighter"
    }, exportedHTML)),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal-footer"
    },
    /*#__PURE__*/
    _react["default"].createElement("em", {
      className: "mr-3"
    }, copied ? "Copied." : ''),
    /*#__PURE__*/
    _react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
      text: exportedHTML,
      onCopy: onCopied
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-primary",
      "data-dismiss": "modal"
    }, "Copy to Clipboard & Close")))))))
  );
};

var _default = ExportHTMLModal;
exports["default"] = _default;